//TODO: Remove this import when bootstrap is removed
import "bootstrap/dist/css/bootstrap.min.css";
import classNames from "classnames";
import { useSelector } from "react-redux";
import { Link, useLocation } from "react-router-dom";

import { FeatureFlags } from "shared/reducers/sysReducer";

import ApplicationState from "store/ApplicationState";

import AdminLink from "./AdminLink";
import BannerController from "./BannerController";
import DjangoLink from "./DjangoLink";
import Header from "./header/Header";
import ToastList from "./toasts/ToastList";
import "./Layout.css";

const Layout = (props: any) => {
  const location = useLocation();
  const features: FeatureFlags = useSelector(
    ({ sys }: ApplicationState) => sys.features
  );

  return (
    <>
      <ToastList />
      <div id="layout">
        <BannerController />
        <Header
          logoLink="/"
          displayProfile
          adminLink={
            features?.djangoAdminLink ? (
              <DjangoLink />
            ) : features?.frontendAdmin ? (
              <AdminLink route="/admin" title="QC Admin" />
            ) : undefined
          }
        >
          {(props.requisitionsNav || props.reportsNav) && (
            <nav className="MainPage__nav">
              {props.requisitionsNav && (
                <Link
                  to="/requisitions"
                  className={classNames("MainPage__navButton", {
                    "MainPage__navButton--selected":
                      location.pathname.includes("/requisitions"),
                  })}
                >
                  Requisitions
                </Link>
              )}
              {props.reportsNav && (
                <Link
                  to="/reports"
                  className={classNames("MainPage__navButton", {
                    "MainPage__navButton--selected":
                      location.pathname.includes("/reports"),
                  })}
                >
                  Reports
                </Link>
              )}
              <Link
                to="/"
                className={classNames("MainPage__navButton", {
                  "MainPage__navButton--selected":
                    !location.pathname.includes("/requisitions") &&
                    !location.pathname.includes("/reports"),
                })}
              >
                Cases
              </Link>
            </nav>
          )}
        </Header>
        <div className="container-fluid">{props.children}</div>
      </div>
    </>
  );
};

export default Layout;
